export default function Contact(){
    return (
        <div className="contact-section" id="Contact">
            <div className="contact-section-title">
                <h4>Let's Work Together!</h4>
                <h1>Contact Me</h1>
            </div>
            <div className="contact-section-content">
                <a>
                    <img src="./img/phone.svg"/>
                    <p>+66 64-337-3025</p>
                </a>
                <a href="mailto:sirapop33408@gmail.com">
                    <img src="./img/email.svg"/>
                    <p>sirapop33408@gmail.com</p>
                </a>
                <a href="https://www.linkedin.com/in/sirapop-tuntithanakij/">
                    <img src="./img/linkedin.svg"/>
                    <p>LinkedIn</p>
                </a>
                <a href="https://github.com/Phaitaras">
                    <img src="./img/github.svg"/>
                    <p>GitHub</p>
                </a>
                <a href="https://line.me/ti/p/~phaitaras69">
                    <img src="./img/line.svg"/>
                    <p>phaitaras69</p>
                </a>
            </div>
        </div>
    )
}